import { render, staticRenderFns } from "./EditIdCard.vue?vue&type=template&id=45e1423a&scoped=true"
import script from "./EditIdCard.vue?vue&type=script&lang=js"
export * from "./EditIdCard.vue?vue&type=script&lang=js"
import style0 from "./EditIdCard.vue?vue&type=style&index=0&id=45e1423a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e1423a",
  null
  
)

export default component.exports